export default __webpack_public_path__ + "static/support-9b34dfee6c8d88dc49e06669dd332a95.png";